import {
  signInWithRedirect,
  signInWithPopup,
  getRedirectResult,
  GoogleAuthProvider,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  User,
} from "firebase/auth";
import { auth } from "./config";

const googleProvider = new GoogleAuthProvider();

/**
 * localhost では popup、それ以外（Tailscale Funnel などの別ドメイン）では redirect でログインする。
 * localhost の redirect は authDomain（firebaseapp.com）が別ドメインになり、
 * 最近のブラウザが別ドメインの保存領域を分けるため、戻ってきてもログインが完了しない
 */
export async function signInWithGoogle() {
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  if (host === "localhost" || host === "127.0.0.1") {
    return signInWithPopup(auth, googleProvider);
  }
  return signInWithRedirect(auth, googleProvider);
}

export async function consumeRedirectResult() {
  return getRedirectResult(auth);
}

export async function signOut() {
  return firebaseSignOut(auth);
}

export function onAuthChange(callback: (user: User | null) => void) {
  return onAuthStateChanged(auth, callback);
}
